import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-achievement-gauge',
    template: `<app-gauge
        [radius]="radius"
        [value]="value * 100"
        [appearance]="appearance"
        [labels]="labels"
        [zones]="zones"
        [maxValue]="maxValue"
        [style]="gaugeStyle"
    ></app-gauge>`,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class AchievementGaugeComponent {
    @Input() public value: number = 0;
    @Input() public radius: number = 150;
    @Input() public appearance: 'dark' | 'light' = 'dark';
    @Input() public labels = [0, 20, 40, 60, 80, 100, 120, 140];
    @Input() public maxValue = 140;
    @Input() public zones = [
        { strokeStyle: '#f43f5e', min: 0, max: 60 }, // rose-500
        { strokeStyle: '#f59e0b', min: 60, max: 90 }, // amber-500
        { strokeStyle: '#10b981', min: 90, max: 120 }, // emerald-500
        {
            strokeStyle: '#3b82f6', // blue-500
            min: 120,
            max: this.value > 1.4 ? this.value * 100 : 140,
        },
    ];
    @Input() public gaugeStyle: 'default' | 'style_1' = 'default';
}
